import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

import { PackageScheduleFundingTypes } from '~constants/maps';

const AppointmentsState = (state: RootState) => state.appointments.appointments;
export const selectAppointments = (state: RootState) => AppointmentsState(state).rows;
export const selectAppointmentsTotal = (state: RootState) => AppointmentsState(state).total;
export const selectAppointmentRowEstimate = (state: RootState) => AppointmentsState(state).estimate;
export const selectCurrentAppointment = (state: RootState) => AppointmentsState(state).row;
export const selectCopyAppointment = (state: RootState) => AppointmentsState(state).copyRow;
export const selectCopyDexSourceId = (state: RootState) => AppointmentsState(state).copyDexSourceId;
export const selectChildAppointment = (state: RootState) => AppointmentsState(state).childRow;
export const selectCurrentAppointmentSignature = (state: RootState) => AppointmentsState(state).rowSignature;
export const selectErrorResponse = (state: RootState) => AppointmentsState(state).error;
export const selectAppointmentMessage = (state: RootState) => AppointmentsState(state).message;
export const selectAppointmentNotification = (state: RootState) => AppointmentsState(state).notification;
export const selectAppointmentLoading = (state: RootState) => AppointmentsState(state).loading;
export const selectAppointmentRowsLoading = (state: RootState) => AppointmentsState(state).rowLoading;
export const selectStatistics = (state: RootState) => AppointmentsState(state).statistics;
export const selectStatisticsLoading = (state: RootState) => AppointmentsState(state).statisticsLoading;

// The DEX tab is gated on CHSP package funding, not on the service type's DEX mapping - a deleted
// but DEX-mapped service type must still surface the tab (it appears in the DEX Readiness report),
// which a dex_code check on the deleted=false service-types list would hide. The effective package
// follows override-over-fixed precedence, matching the api CHSP-funding classification so the tab
// and the DEX Readiness / Export screens agree on which appointments are in scope.
export const selectIsCurrentAppointmentChspFunded = createSelector(selectCurrentAppointment, (appointment) => {
  const effectivePackage = appointment?.package_override ?? appointment?.package_fixed;
  return effectivePackage?.funding_type_id === PackageScheduleFundingTypes.CHSP;
});
